import { CoreAjaxHelper } from './CoreAjaxHelper'; 
import * as firebase from 'firebase';
/**
 * kalau proses dalam proses
 */
export const ERROR_CODE_PROCESS_IN_PROGRESS: string = 'PROCESS_IN_PROGRESSS';
/**
 * checker status untuk pended request
 */
export class PendedRequestAjaxRechecker {

    /**
     * berapa kali check boleh dilakukan
     */
    private maxRecheckTime: number = 10000;
    /**
     * berapa kali maksimal recheck
     */
    private rechecCount: number = 0;
    /**
     * 
     */
    private timeout: any;
    /**
     * durasi pengecekan(dalam second)
     */
    private recheckDuration: number = 10;
    /**
     * reference doc yang di listent sekarang
     */
    private currentDocRef: firebase.database.Reference ;
    /**
     * data req header current
     */
    // private currentReqData: any ; 
    // private accept: (d: any) => any = null!;  
    // private reject: (exc: any) => any =  null!; 
    constructor(private coreAjaxHelper: CoreAjaxHelper,  private firebaseApp: firebase.app.App   , recheckParameter?: {
        /**
         * berapa kali maksimal recheck
         */
        maxRecheckTime: number;
        /**
         * durasi recheck
         */
        rechecDurationSecond?: number;
    }) {
        if (recheckParameter) {
            if (recheckParameter.rechecDurationSecond) {
                this.recheckDuration = recheckParameter.rechecDurationSecond;
            }
            this.maxRecheckTime = recheckParameter.maxRecheckTime;

        }
    }

    /**
     * run ajax request dengan result pended result
     * @param method method request
     * @param url url dari request
     * @param data data hasil
     */
    public runPendedResultAjaxRequest(method: 'get' | 'post' | 'put' | 'delete', url: string, data?: any): Promise<any> {
        return new Promise<any/*datatype*/>(async (accept: (n: any) => any, reject: (exc: any) => any) => {
            try {
                let prms: Promise<any> = null!;
                if (method === 'get') {
                    prms = this.coreAjaxHelper.get(url);
                } else if (method === 'post') {
                    prms = this.coreAjaxHelper.post(url, data);
                } else if (method === 'delete') {
                    prms = this.coreAjaxHelper.del(url);
                } else if (method === 'put') {
                    prms = this.coreAjaxHelper.put(url);
                } else {
                    prms = Promise.reject({ code: 'UNSUPPORTED_METHOD' + method, message: `Method: ${method} not supported` });
                }
                prms.then(d => {
                    if (d.processType && d.processType === 'BACKGROUND_TASK') {
                        const key: string = d.key;
                        if (d.firebaseCheckerPath && d.firebaseCheckerPath.length > 0) {
                            this.deployFirebaseListener(d.firebaseCheckerPath, key, accept, reject);
                            return;
                        } else {
                            this.runCheck(key, accept, reject);
                            return;
                        }
                    } else {
                        accept(d);
                    }
                    return;
                }).catch(reject);
            } catch (exc) {
                reject(exc);

            }
        });
    }
    /**
     * clean timeout terakhir
     */
    clearChecker() {
        if (this.currentDocRef) {
            this.currentDocRef.off('value');
            this.currentDocRef = null!;
        }
        //
        if (!this.timeout) {
            return;
        }
        clearTimeout(this.timeout);
        this.timeout = null;
    }
    private deployFirebaseListener(path: string, id: any, accept: (n: any) => any, reject: (exc: any) => any) {
        this.clearChecker() ;
        const clsName: string = (this as any).constructor.name ; 
        const mthd: string = 'runCheck' ; 
        const prfx: string = `[${clsName}#${mthd}]` ; 
        this.currentDocRef = this.firebaseApp.database().ref(path);
        this.currentDocRef.on('value' ,  (snapshot: any) => { 
            try {
                console.log(`${prfx} Recieved snapshot: `, snapshot);
                if (!snapshot) {
                    console.error(`${prfx} dari firebase, path : ${path} melaporkan null. tidak di proses`);
                    return;
                }
                if (!snapshot.val()) {
                    let exc = {
                        errorCode: "ERROR",
                        code: "ERROR",
                        message: "Not Available "
                    };
                    reject(exc); 
                } else  {
                    const val: any = snapshot.val();
                    if (!val) {
                        console.error(`${prfx} dari firebase, path : ${path} melaporkan null. val null`);
                        return;
                    }
        
                    if (val.statusCode === "COMPLETE") {
                        console.log(`${prfx} menerima data update untuk path ${path} `, val);
                        // let haveChange: boolean = false;
                        this.coreAjaxHelper.post(
                            '/dynamics/system/pended-task-result.svc',
                            {
                                id: id
                            }).then(d => {
                                this.clearChecker();
                                //
                                if ( typeof d.responseData === 'string' ) {
                                    d.responseData = JSON.parse(d.responseData);
                                }
        
                                if (d.statusCode === 'ERROR') {
                                    reject(d.responseData);
                                    return;
                                } else if (d.statusCode === 'COMPLETE') { 
                                    accept(d.responseData);
                                    return;
                                }
                                accept(d.responseData);
                            }).catch(exc => {
                                if (exc.errorCode === "PROCESS_IN_PROGRESSS" || exc.code === "PROCESS_IN_PROGRESSS") {
                                    return;
                                }
                                reject(exc); 
                                this.clearChecker();
                            });
                    } else if (val.statusCode === "ERROR") {
                        let exc = {
                            errorCode: "ERROR",
                            code: "ERROR",
                            message: "Not Available "
                        };
                        reject(exc); 
                    }
                }  
            } catch (exc) {
                reject(exc); 
            }
            
        });
    }
    /**
     * run checker process
     */
    private runCheck(key: string, accept: (d: any) => any, reject: (exc: any) => any) {
        const clsName: string = (this as any).constructor.name;
        const mthdName: string = 'runCheck';
        const prfx: string = `[${clsName}#${mthdName}]`;
        //
        if (this.timeout) {
            try {
                clearTimeout(this.timeout);
                this.timeout = null;
            } catch (exc) {
                //
                console.error(`${prfx} gagal clear timeout. error : `, exc);
            }
        }

        this.rechecCount += 1;
        if (this.rechecCount >= this.maxRecheckTime) {
            console.error(`${prfx} recheck sudah melebihi maks di ijinkan: ${this.maxRecheckTime} recheck di hentikan`);
        }

        setTimeout(
            () => {
                //
                this.coreAjaxHelper.post(
                    '/dynamics/system/pended-task-result.svc',
                    {
                        id: key
                    }).then(d => {
                        this.clearChecker();
                        //
                        if (d.statusCode === 'ERROR') {
                            reject(d.responseData);
                            return;
                        } else if (d.statusCode === 'COMPLETE') {
                            accept(d.responseData);
                            return;
                        }
                        accept(d.responseData);
                    }).catch(exc => {
                        if (ERROR_CODE_PROCESS_IN_PROGRESS === exc.code || ERROR_CODE_PROCESS_IN_PROGRESS === exc.errorCode) {
                            this.runCheck(key, accept, reject);
                            return;
                        } else {
                            this.clearChecker();
                            reject(exc);

                        }
                    });
            },
            this.recheckDuration * 1000);
    }

}


// WEBPACK FOOTER //
// ./src/utils/PendedRequestAjaxRechecker.ts